export class FuzzyComparePlainObject {
    public leftExpression: string;
    public rightExpression: string;
    public overrideSimilarityThreshold: number = 0;
}
